<template>
    <v-dialog
        max-width="600"
        transition="dialog-top-transition"
        v-model="isOpen"
    >
        <v-card elevation="0">
            <v-card-title primary-title class="justify-center mb-2">
                <div
                    v-if="$vuetify.breakpoint.xs"
                    class="primary--text text-overline ml-2"
                >
                    Añadiendo Upfront Crossell
                </div>
                <div
                    v-else
                    class="
                        font-weight-light
                        primary--text
                        text-h4
                        ml-2
                        text-capitalize
                    "
                >
                    Añadiendo Upfront Crossell
                </div>
            </v-card-title>

            <v-card-text>
                <v-row no-gutters>
                    <v-col cols="12" md="6">
                        <v-card class="pa-2 mt-1" elevation="0" text>
                            <!-- <v-row>
                                <v-col md="12" class="mb-md-1 mt-md-1">
                                    <h4 class="font-weight-light primary--text">
                                        Cantidad
                                    </h4>
                                </v-col>
                            </v-row>
                            <v-divider class="mb-3 mt-n4"></v-divider> -->
                            <v-text-field
                                v-model="upfrontHistoryForm.upfront"
                                class="pt-1 mx-2"
                                clearable
                                label="Importe"
                                type="number"
                                :rules="[rules.required, rules.gtzero]"
                            ></v-text-field>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card
                            class="pa-2 mt-1 ml-md-1"
                            elevation="0"
                            text
                        >
                            <!-- <v-row>
                                <v-col md="12" class="mb-md-1 mt-md-1">
                                    <h4 class="font-weight-light primary--text">
                                        Tipo
                                    </h4>
                                </v-col>
                            </v-row>
                            <v-divider class="mb-3 mt-n4"></v-divider> -->
                            <v-select
                                clearable
                                disabled
                                v-model="upfrontHistoryForm.tipo"
                                :items="['CROSSELL']"
                                class="pt-1 mx-2"
                                label="Tipo"
                            ></v-select>
                        </v-card>
                    </v-col>
                </v-row>

                <v-row no-gutters>
                    <v-col cols="12">
                        <v-card class="pa-2 mt-1" elevation="0" text>
                            <!-- <v-row>
                                <v-col md="12" class="mb-md-1 mt-md-1">
                                    <h4 class="font-weight-light primary--text">
                                        Objetivo
                                    </h4>
                                </v-col>
                            </v-row>
                            <v-divider class="mb-3 mt-n4"></v-divider> -->
                            <v-select
                                clearable
                                multiple
                                chips
                                v-model="upfrontHistoryForm.familia_objetivo"
                                :items="filteredTipoObjetivo"
                                item-text="nombre"
                                return-object
                                class="pt-1 mx-2"
                                label="Objetivo"
                            >
                            </v-select>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12" md="6">
                        <v-card elevation="0" class="pa-2 mt-1">
                            <!-- <v-row>
                                <v-col md="12" class="mb-md-1 mt-md-1">
                                    <h4 class="font-weight-light primary--text">
                                        Filtro Operador
                                    </h4>
                                </v-col>
                            </v-row>
                            <v-divider class="mb-3 mt-n4"></v-divider> -->
                            <v-select
                                clearable
                                chips
                                :items="opciones.tarifas.operator"
                                item-text="human"
                                item-value="encoded"
                                v-model="operator"
                                :label="operator ? operator : 'Operador'"
                            >
                                <template #selection="{ item }">
                                    <v-chip color="primary" class="white--text">
                                        <v-icon> mdi-signal-variant </v-icon>
                                        {{ item.human }}
                                    </v-chip>
                                </template>
                            </v-select>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card elevation="0" class="pa-2 mt-1 ml-md-1">
                            <!-- <v-row>
                                <v-col md="12" class="mb-md-1 mt-md-1">
                                    <h4 class="font-weight-light primary--text">
                                        Filtro Segmento
                                    </h4>
                                </v-col>
                            </v-row>
                            <v-divider class="mb-3 mt-n4"></v-divider> -->
                            <v-select
                                clearable
                                hide-selected
                                chips
                                :items="opciones.tarifas.segment"
                                item-text="human"
                                item-value="encoded"
                                v-model="segment"
                                label="Segmento"
                            >
                                <template #selection="{ item }">
                                    <v-chip
                                        color="yellow darken-2"
                                        class="white--text"
                                    >
                                        <v-icon> mdi-call-merge </v-icon>
                                        {{ item.human }}
                                    </v-chip>
                                </template>
                            </v-select>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-card elevation="0" class="pa-2 my-1">
                            <!-- <v-row>
                                <v-col md="12" class="mb-md-1 mt-md-1">
                                    <h4 class="font-weight-light primary--text">
                                        Tarifas/Adicionales/SVA Aplicadas
                                    </h4>
                                </v-col>
                            </v-row>
                            <v-divider class="mb-3 mt-n4"></v-divider> -->
                            <v-row class="mb-md-n3">
                                <v-col md="12">
                                    <v-autocomplete
                                        clearable
                                        multiple
                                        chips
                                        :items="availableTariffsDropDown"
                                        persistent-hint
                                        :hint="
                                            availableTariffsDropDown.length.toString() +
                                            ' disponibles'
                                        "
                                        item-text="name"
                                        item-value="id"
                                        :no-data-text="
                                            tariffsDropDown.length == 0
                                                ? 'No hay tarifas disponibles'
                                                : 'Selecciona un operador primero'
                                        "
                                        v-model="SelectedTariffs"
                                        label="Tarifas"
                                    >
                                        <template #selection="{ item }">
                                            <v-chip
                                                @click:close="remove(item)"
                                                close
                                                color="pink"
                                                class="white--text"
                                            >
                                                <v-icon>
                                                    mdi-credit-card
                                                </v-icon>
                                                {{
                                                    item.name
                                                        ? item.name
                                                        : item.id
                                                }}
                                            </v-chip>
                                        </template>
                                        <template #item="{ item }">
                                            <v-row>
                                                <v-col cols="12">
                                                    {{
                                                        item && item.name
                                                            ? item.name
                                                            : item.id
                                                    }}
                                                </v-col>
                                            </v-row>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions class="justify-end">
                <v-btn text color="warning" @click="reset"> Limpiar </v-btn>
                <v-btn text color="red" @click="isOpen = false"> Cerrar </v-btn>
                <v-btn color="success" @click="submit"> Añadir </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { clone } from '@/util/libUtil.js';
import { mapState, mapActions } from 'vuex';
import defaultUpfrontForm from '@/util/management/defaultUpfrontForm.js';

export default {
    name: 'TariffManagementCrossForm',
    data: () => ({
        SelectedTariffs: [],
        operator: null,
        segment: null,
        rules: {
            required: (value) => !!value || 'Complete este campo',
            gtzero: (value) => value >= 0 || 'Solo mayor que 0',
        },
    }),
    methods: {
        reset() {
            this.operator = null;
            this.segment = null;
            this.SelectedTariffs = [];
            this.upfrontHistoryForm = clone(defaultUpfrontForm);
        },
        submit() {
            this.upfrontHistoryForm.content_type = 25;

            this.SelectedTariffs.forEach((element) => {
                this.upfrontHistoryForm.object_id = element;
                this.addUpfrontHistory();
            });
        },
        remove(item) {
            let index = this.SelectedTariffs.indexOf(item.id);
            this.SelectedTariffs.splice(index, 1);
        },
        ...mapActions('ManagementBase', ['addUpfrontHistory']),
    },
    computed: {
        availableTariffsDropDown() {
            let filterIs_active = (item) => (item.is_active = true);
            let filterOperator = (item) =>
                this.operator ? item.operator == this.operator : true;
            let filterSegment = (item) =>
                this.segment ? item.segment == this.segment : true;
            let filterType = (item) => item.type == 'TARIFF';
            let filterCornvergent = (item) =>
                item.name.toLowerCase().includes('MAS') ||
                item.name.toLowerCase().includes('+');

            return this.tariffsDropDown.filter(
                (item) =>
                    filterIs_active(item) &&
                    filterOperator(item) &&
                    filterSegment(item) &&
                    filterType(item) &&
                    filterCornvergent(item)
            );
        },
        filteredTipoObjetivo() {
            return this.tipoObjetivo.filter((item) =>
                item.nombre.toLowerCase().includes('fijo')
            );
        },
        upfrontHistoryForm: {
            get() {
                return this.$store.state.ManagementBase.baseForm
                    .upfrontHistoryForm;
            },
            set(val) {
                this.$store.commit('ManagementBase/upfrontHistoryForm', val);
            },
        },
        isOpen: {
            get() {
                let val =
                    this.$store.state.ManagementBase.tariffManagement
                        .isOpenCrossForm;
                if (val) this.upfrontHistoryForm.tipo = 'CROSSELL';
                else this.reset();

                return val;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/tariffManagement/isOpenCrossForm',
                    val
                );
            },
        },
        ...mapState('ManagementBase', {
            tipoObjetivo: (state) => state.tipoObjetivo,
        }),
        ...mapState('ManagementBase/promotionManagement', {
            tariffsDropDown: (state) => state.tariffsDropDown,
        }),
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
    },
};
</script>